import { Box, Button, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import axios from "axios";
import { Cookies } from "react-cookie";
import { goAppUrl } from "assets/js/apphandle";
import AlertComplete from "components/ui/alert-complete";
import { useHistory } from "react-router-dom";
import {
  loadPayListAction,
  loadCheckTermsAction,
  resetPay,
} from "redux/reducers/pay";
import AlertConfirm from "components/ui/alert-confirm";
import { getCardName, cardImg } from "assets/js/common";
import Loading from "components/ui/loading";

const cookies = new Cookies();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Pay() {
  const dispatch = useDispatch();
  const history = useHistory();

  const swiperRef = useRef(null);

  const no = cookies.get("no");

  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [text, setText] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);

  const { loading, easyCardList, checkTerms } = useSelector(
    (state) => state.pay
  );

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  const handleAlertOpen = (mode, item) => {
    setAlertMode(mode);
    setSelectedItem(item);
    setOpen(true);
  };

  useEffect(() => {
    dispatch(
      loadAction({ back: true, title: "간편결제 카드관리", menu: false })
    );
    dispatch(loadPayListAction());

    return () => {
      dispatch(resetPay());
    };
  }, []);

  useEffect(() => {
    if (easyCardList.length > 0) {
      dispatch(loadCheckTermsAction());
    }
  }, [easyCardList]);

  useEffect(() => {
    if (checkTerms == "F") {
      let no = cookies.get("no");
      const url = `${
        axios.defaults.baseURL
      }/api/app/easy-card/terms-confirm.do?mbrNo=${no}`;
      goAppUrl(url, -1);
    }
  }, [checkTerms]);

  // 본인인증
  const goCertCard = () => {
    window.appReturnDataHandle = (data) => {
      if (data) {
        setReturnData(decodeURI(data));
      }
    };
    const url = `${axios.defaults.baseURL}/api/app/easy-card/cert.do`;
    location.href = `csrmegamart://internal-url?close=N&new=Y&url=${url}&d=&top=1`;
    // window.open(url, "", "width = 500, height = 800");
  };

  const setReturnData = (result) => {
    result = JSON.parse(result);
    if (result.rst == "success") {
      if (result.isUser !== "true" || result.no != no) {
        setText("잘못된 사용자 정보입니다.<br/> 다시 인증해주세요.");
        handleAlertOpen("invalid");
        setOpen(true);
      } else if (result.isUser === "true" && result.no == no) {
        goRegistCard(result.salt);
      }
    }
  };

  const setReturnData2 = (result) => {
    result = JSON.parse(result);
    if (result.rst == "success" && result.niceCid) {
      history.push(`/mypage/shopping/pay/sign/${result.niceCid}`);
    } else {
      alert(result.msg);
    }
  };

  const slideChange = (swipe) => {
    let item = easyCardList[swipe.realIndex];
    // handleChange(item);
  };

  const registRepresentCard = (item) => {
    axios
      .post(`/api/app/easy-card/set-rep`, {
        // niceCid: "NABA05226000000000000000007645"
        niceCid: item.niceCid,
      })
      .then((res) => {
        dispatch(loadPayListAction());
      });
  };

  // 카드 등록
  const goRegistCard = (salt) => {
    //app return
    window.appReturnDataHandle = (data) => {
      if (data) {
        setReturnData2(decodeURI(data));
      }
    };
    const url = `${
      axios.defaults.baseURL
    }/api/app/easy-card/regist.do?salt=${encodeURIComponent(salt)}`;
    goAppUrl(url, -1);
    //8L3ZCQP1nGFTSyTTsmE2VniaqkbaVq3JS02PF1yV3yC8BdbOU6pOam0YPxmZ49LfOhYN0OMiDSxadfutCn%2BpVZZQFAALb4bWLIbbAHz8oP2HytFxZc3U1lwXmYoMFFPp4a3noFQ1ht%2FcATVXm%2BbdR3gBIyb7Teh0TDiLVgizFY3eQ3gj%2BbaC3wu4Cdo7mwkF
    // window.open(url, "", "width = 500, height = 800");
  };

  const removeCard = () => {
    axios
      .post(`/api/app/easy-card/remove`, {
        // niceCid: "NABA05226000000000000000007645"
        niceCid: selectedItem.niceCid,
      })
      .then((res) => {
        setSelectedItem("");
        handleAlertClose();
        dispatch(loadPayListAction());
      });
    // console.log("remove card", item, i);
  };

  const setReturnData3 = (result) => {
    result = JSON.parse(result);
    if (result.rst == "success" && result.niceCid) {
      history.push(`/mypage/shopping/pay/sign/${result.niceCid}`);
    }
  };

  const changePwd = () => {
    //app return
    window.appReturnDataHandle = (data) => {
      if (data) {
        setReturnData3(decodeURI(data));
      }
    };
    const url = `${
      axios.defaults.baseURL
    }/api/app/easy-card/change-password.do?mbrNo=${no}`;
    goAppUrl(url, -1);
  };

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={loading ? true : false} />
      <div className="Pay container nopad">
        <div className="pay-wrap">
          {easyCardList.length > 0 ? (
            <Swiper
              // pagination={true}
              // modules={[Pagination]}
              ref={swiperRef}
              className="mySwiper card-list"
              slidesPerView={"auto"}
              centeredSlides={true}
              spaceBetween={25}
              onSwiper={slideChange}
              onSlideChange={slideChange}
            >
              {easyCardList.map((item, i) => (
                <SwiperSlide key={i}>
                  <div className="card-item">
                    <div className="tit">{item.nickName}</div>
                    <div
                      className="card"
                      style={{
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL
                        }/images/card-img/card_add_${cardImg(
                          item.cardCompCode
                        )}.png)`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100%",
                      }}
                    >
                      {item.repYn == "Y" && (
                        <div className="represent-badge">대표 카드</div>
                      )}
                      {/* <div className="logo">{item.lastNum}</div> */}
                      <div className="no">**** **** **** {item.lastNum}</div>
                      <div className="exp">
                        <p>EXP **/**</p>
                        <p>{getCardName(item.cardCompCode)}</p>
                      </div>
                      {/* <div className="inf" /> */}
                    </div>
                    <div className="btn-wrap">
                      <Button
                        onClick={() => {
                          handleAlertOpen("repConfirm", item);
                        }}
                      >
                        대표카드 설정
                      </Button>
                      <Button
                        onClick={() => {
                          handleAlertOpen("delConfirm", item);
                        }}
                      >
                        카드삭제
                      </Button>
                    </div>
                  </div>
                  {/* <LazyCDNImage cdnUrl={item} style={{ height: "300px" }} /> */}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="card-list">
              <div className="card-item">
                <div className="tit">카드를 등록해주세요.</div>
                <div
                  className="card card-big"
                  // style={{
                  //   backgroundImage: `url(${item.imgUrl})`,
                  //   backgroundRepeat: "no-repeat",
                  //   backgroundSize: "100%",
                  // }}
                >
                  <div className="logo">CARD</div>
                  <div className="no">**** **** **** ****</div>
                  <div className="exp">
                    <p>EXP **/**</p>
                    {/* <p>신한카드</p> */}
                  </div>
                  <div className="inf">VISA</div>
                </div>
              </div>
            </div>
          )}
          <div className="add-btn">
            <Button
              variant="outlined"
              fullWidth
              color="primary"
              onClick={() => {
                changePwd();
              }}
            >
              결제 비밀번호 변경
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={goCertCard}
            >
              카드 추가하기
            </Button>
          </div>
        </div>
        <Box className="notice is-bottom">
          <p className="title">
            <i className="ico-noti" />
            유의사항
          </p>
          <ul className="list list-dot color-info font-14">
            <li>등록 후 앱 바코드 스캔 시 자동으로 결제됩니다.</li>
            <li>카드사 정책에 따라 일부 카드는 등록이 불가할 수 있습니다.</li>
          </ul>
        </Box>
        {alertMode == "invalid" ? (
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={text}
            action={handleAlertClose}
          />
        ) : alertMode == "delConfirm" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"간편결제 카드를 삭제하시겠습니까?"}
            action={() => {
              removeCard();
            }}
          />
        ) : alertMode == "useCardDelConfirm" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"현재 사용중인 대표 카드를 삭제하시겠습니까?"}
            action={handleAlertClose}
          />
        ) : alertMode == "repConfirm" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"선택하신 카드를 대표카드로 설정하시겠습니까?"}
            action={() => {
              registRepresentCard(selectedItem);
              handleAlertClose();
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
